import { useState } from 'react'
import { useAuth } from '../lib/auth'

export default function Login() {
  const { login, needsSetup, setup } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      if (needsSetup) {
        await setup(username, password, displayName || username)
      } else {
        await login(username, password)
      }
    } catch (err: any) {
      let msg = 'فشل الدخول'
      try {
        const parsed = JSON.parse(err.message)
        msg = parsed.error || msg
      } catch {
        msg = err.message || msg
      }
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-vertex-deep flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-vertex-gold font-bold text-2xl">Vertex</h1>
          <p className="text-vertex-gold-light text-sm">Content Factory</p>
        </div>

        {/* Card */}
        <div className="bg-vertex-navy rounded-lg border border-vertex-surface p-6">
          <h2 className="text-lg font-bold text-white mb-1 text-center">
            {needsSetup ? 'إنشاء حساب الأدمن الأول' : 'تسجيل الدخول'}
          </h2>
          {needsSetup && (
            <p className="text-xs text-gray-400 text-center mb-4">
              أول مرة — أنشئ حساب superadmin
            </p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            <div>
              <label className="block text-xs text-gray-400 mb-1">اسم المستخدم</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
                autoFocus
                className="w-full bg-vertex-deep border border-vertex-surface rounded px-3 py-2 text-sm text-white focus:border-vertex-gold outline-none"
                placeholder="admin"
                dir="ltr"
              />
            </div>

            {needsSetup && (
              <div>
                <label className="block text-xs text-gray-400 mb-1">الاسم الظاهر</label>
                <input
                  type="text"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  className="w-full bg-vertex-deep border border-vertex-surface rounded px-3 py-2 text-sm text-white focus:border-vertex-gold outline-none"
                  placeholder="Mohamed"
                  dir="ltr"
                />
              </div>
            )}

            <div>
              <label className="block text-xs text-gray-400 mb-1">كلمة المرور</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                autoComplete={needsSetup ? 'new-password' : 'current-password'}
                className="w-full bg-vertex-deep border border-vertex-surface rounded px-3 py-2 text-sm text-white focus:border-vertex-gold outline-none"
                placeholder="••••••••"
                dir="ltr"
              />
            </div>

            {error && (
              <div className="bg-red-900/30 border border-red-800 rounded px-3 py-2 text-xs text-red-400">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-vertex-gold text-vertex-deep py-2 rounded text-sm font-bold hover:bg-vertex-gold-light disabled:opacity-50 transition-colors"
            >
              {loading ? '...' : needsSetup ? 'إنشاء الحساب' : 'دخول'}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-gray-600 mt-4">Vertex Business School</p>
      </div>
    </div>
  )
}
